import { Button, Group, Stack, Text } from "@assetwatch/ui";

export const STALE_SAVE_MESSAGE =
  "This Work Order changed while you were editing.";

type WorkOrderStaleSaveNoticeProps = {
  onRefresh: () => void;
};

/**
 * Shown when a save is refused because the Work Order changed after it was
 * opened. Refresh rebases the local changes on the latest version while
 * keeping untouched fields current.
 */
export function WorkOrderStaleSaveNotice({
  onRefresh,
}: WorkOrderStaleSaveNoticeProps) {
  return (
    <Stack gap={8} role="alert">
      <Text size="sm" tone="negative">
        {STALE_SAVE_MESSAGE}
      </Text>
      <Text size="sm" tone="subtle">
        Refresh to load the latest version. Your edits will be kept so you can
        review and save them again.
      </Text>
      <Group gap={8}>
        <Button onClick={onRefresh} size="sm" variant="outline">
          Refresh and keep edits
        </Button>
      </Group>
    </Stack>
  );
}
